<div class="invite-to-meetings" [class.mobile]="deviceService.isMobile()">
  <div class="header">
    <app-invite-header [searchReset]="resetSearch" (searchChanged)="onSearchChanged($event)" (searchClosed)="onCloseSearch()"></app-invite-header>
  </div>
  <div class="body">
    <ng-container *ngIf="users.loaded && users.items.length; else stub">
      <ng-container *ngFor="let user of users.items; trackBy: trackByFn">
        <app-invite-user-card
          [user]="user"
          [isInvited]="isUserInvited(user)"
          (invite)="onInvite($event)">
        </app-invite-user-card>
      </ng-container>
    </ng-container>

    <ng-template #stub>
      <app-invite-stub></app-invite-stub>
    </ng-template>
  </div>
  <!-- TODO add invitation by link and by email-->
  <div class="footer">
    <app-invite-footer [meeting]="meetingData"></app-invite-footer>
  </div>
</div>

